export default __webpack_public_path__ + "static/media/ellipse30Map5.4ffb7ec9.svg";